import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineLpHead のスタイル
 */
export const hotlineLpHeadStyle = tv({
    defaultVariants: {
        marginTop: 'normal',
        subTextPositionForPc: 'center',
    },
    slots: {
        base: ['text-center'],
        mainText: [
            'font-bold text-[#231916]',
            'text-[20px] sm:text-[32px] lg:text-[36px] xl:text-[40px]',
            'leading-normal sm:leading-[46px] lg:leading-[52px] xl:leading-[58px]',
            'max-lg:mt-8',
        ],
        subText: ['text-[14px] sm:text-[16px] text-[#4881F1] font-bold'],
    },
    variants: {
        /** PC時のテキスト間の余白 */
        marginTopForPc: {
            normal: {
                mainText: [],
            },
            wide: {
                mainText: ['sm:mt-24'],
            },
        },
        /** PC時のサブテキストの位置 */
        subTextPositionForPc: {
            center: {
                base: [],
            },
            left: {
                base: ['lg:text-left'],
            },
        },
    },
});
